<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	     -->
			<!-- School  -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">School</label>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false || UserLevelID != 1"
						value="1"
						label="All Schools"
						[(ngModel)]="selectedGroupValue"
						(onClick)="onSchoolChange($event)"
					></p-radioButton>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false"
						value="2"
						label="Current School Only"
						[(ngModel)]="selectedGroupValue"
						(onClick)="onSchoolChange($event)"
					></p-radioButton>
				</div>
			</div>

			<!-- 	     -->
			<!-- CODE    -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Code</label>
				</div>

				<div style="margin-left: 10px">
					<input
						type="text"
						pInputText
						[(ngModel)]="rPenaltyCD"
						maxlength="50"
						style="width: 350px"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 50 characters</label>
				</div>
			</div>
			<!-- 	     	 -->
			<!-- Description -->
			<!-- 	     	 -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Description</label>
				</div>

				<div style="margin-left: 10px">
					<input
						type="text"
						pInputText
						[(ngModel)]="rPenaltyDesc"
						maxlength="100"
						style="width: 350px"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!--  	   	              -->
			<!-- Action Type Selector -->
			<!-- 		              -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Action Type</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedPenaltyTypeSelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
						[(ngModel)]="SelectedPenaltyType"
						(ngModelChange)="onPenaltyTypeChange($event)"
					>
						<option *ngFor="let r of lstPenaltyTypeItems" [ngValue]="r">
							{{ r.PenaltyTypeDesc }}
						</option>
					</select>
				</div>

				<div class="horizontal-group" [style.display]="SelectedPenaltyType.PenaltyTypeID == 3 ? 'none' : 'flex'">
					<div style="margin-left: 15px">
						<label>Duration (days)</label>
					</div>

					<div style="margin-left: 10px">
						<label style="font-size: smaller">Min</label>
					</div>

					<div style="margin-left: 5px">
						<input type="text" pInputText [(ngModel)]="rMinDurationDayCount" maxlength="4" style="width: 35px" [disabled]="isViewOnly == true" />
					</div>

					<div style="margin-left: 10px">
						<label style="font-size: smaller">Max</label>
					</div>

					<div style="margin-left: 5px">
						<input type="text" pInputText [(ngModel)]="rMaxDurationDayCount" maxlength="4" style="width: 35px" [disabled]="isViewOnly == true" />
					</div>
				</div>
			</div>

			<!--  	   	                -->
			<!-- Workflow Type Selector -->
			<!-- 		                -->
			<div class="column-item" *ngIf="SelectedPenaltyType.PenaltyTypeID != 3">
				<div>
					<label class="column-item-label">Workflow Type</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedWorkflowTypeSelector"
						style="font-size: smaller"
						[disabled]="(isAdd == false && UserID != 0) || isViewOnly == true || isLimitedEdit == true"
						[(ngModel)]="SelectedWorkflowType"
						(ngModelChange)="onWorkflowTypeChange($event)"
					>
						<option *ngFor="let r of lstWorkflowTypeItems" [ngValue]="r">
							{{ r.WorkflowTypeDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	        -->
			<!-- Alert Selector -->
			<!-- 		        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Alert</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedAlertSelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
						[(ngModel)]="SelectedAlert"
						(ngModelChange)="onAlertChange($event)"
					>
						<option *ngFor="let r of lstAlertItems" [ngValue]="r">
							{{ r.AlertDesc }}
						</option>
					</select>
				</div>

				<div class="horizontal-group" [style.display]="SelectedAlert.SoundLibraryID > 1 ? 'flex' : 'none'">
					<div style="margin-left: 15px">
						<label>Sound</label>
					</div>

					<div style="margin-left: 5px">
						<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onPlay()" [disabled]="isBusy == true">Play</button>
						<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onStop()" [disabled]="isBusy == true">Stop</button>
					</div>

					<div style="margin-left: 10px">
						<label style="font-size: smaller">{{ SelectedAlert.SoundFile }}</label>
					</div>
				</div>
			</div>

			<!--  	   	         				-->
			<!-- Is Notification / Is Classroom -->
			<!-- 		        				-->
			<div class="column-item">
				<!-- NOTE: Penalty.IsNotification is deprecated (Was used before CAASS Notify and the Portal Apps) -->
				<!--
				<div>
					<label class="column-item-label">Notification</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsNotification" [binary]="true" [disabled]="isViewOnly == true || isLimitedEdit == true"></p-checkbox>
				</div>
				-->

				<div>
					<label style="margin-left: 20px">Can be added from Classroom</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsEDCRAssignable" [binary]="true" [disabled]="isViewOnly == true || isLimitedEdit == true"></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Allow Partial Day Suspension</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsPartialDay" [binary]="true" [disabled]="isViewOnly == true || isLimitedEdit == true"></p-checkbox>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="main-grade-group">
	<div>
		<!-- 					  -->
		<!-- Display UnAssigned   -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstGradeItems"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="multiple"
				(onSort)="onHandleSort($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 20, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th class="fixwidth-04">
							<p-checkbox
								[(ngModel)]="isSelectAll"
								[binary]="true"
								(onChange)="onSelectAll($event)"
								[disabled]="isViewOnly == true || isLimitedEdit == true"
							></p-checkbox>
						</th>
						<th pSortableColumn="GradeLevelDesc">Grade<p-sortIcon field="GradeLevelDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rGradeItem>
					<tr>
						<td class="fixwidth-04">
							<div>
								<p-checkbox
									[(ngModel)]="rGradeItem.isSelected"
									[binary]="true"
									[disabled]="isViewOnly == true || isLimitedEdit == true"
								></p-checkbox>
							</div>
						</td>

						<td>
							<div>
								{{ rGradeItem.GradeLevelDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						-->
		<!-- Display When No Grades -->
		<!-- 						-->
		<div style="padding: 20px" [style.display]="lstDistrictGradeItemsItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No Grades To Select...</label>
		</div>
	</div>
</div>

<div class="main-grade-group">
	<div>
		<!-- 					  -->
		<!-- Display UnAssigned   -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstClarifyingActions"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="multiple"
				(onSort)="onHandleSort($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 20, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th class="fixwidth-04">
							<p-checkbox
								[(ngModel)]="isCASelectAll"
								[binary]="true"
								(onChange)="onCASelectAll($event)"
								[disabled]="isViewOnly == true || isLimitedEdit == true"
							></p-checkbox>
						</th>
						<th pSortableColumn="ClarifyingActionDesc">Clarifying Action<p-sortIcon field="ClarifyingActionDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-ClarifyingAction>
					<tr>
						<td class="fixwidth-04">
							<div>
								<p-checkbox
									[(ngModel)]="ClarifyingAction.isSelected"
									[binary]="true"
									[disabled]="isViewOnly == true || isLimitedEdit == true"
								></p-checkbox>
							</div>
						</td>

						<td>
							<div>
								{{ ClarifyingAction.ClarifyingActionDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 									-->
		<!-- Display When No Clarifying Actions -->
		<!-- 									-->
		<div style="padding: 20px" [style.display]="lstClarifyingActions.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No Clarifying Actions To Select...</label>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onAddUpdate()" [disabled]="isBusy == true || isViewOnly == true">Save</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
